import { analytics } from "utils/analytics"
import { slugify } from "core/utils/slugify"

const LEGACY_NAV_SLUGS = {
  "Newsletter site": "nav_creator-profile",
  Sponsorships: "nav_newsletter-sponsorships",
  "Email sequences": "nav_sequences"
}

/**
 * Event name for a nav entry, derived from its label. Renamed items map back to
 * their old slug so historical data stays comparable.
 *
 * A missing label slugifies to "", which tracks as the catch-all `nav_` event
 * and merges every mislabeled link into one bucket. Throw in dev/test so it
 * surfaces when the link renders; keep the old `nav_` in production.
 */
export const navName = label => {
  const legacy = LEGACY_NAV_SLUGS[label]
  if (legacy) return legacy

  const slug = slugify(label)
  if (!slug && process.env.NODE_ENV !== "production") {
    throw new Error(
      `navName received an empty label, which would track as the catch-all "nav_" event. ` +
        `Pass a non-empty label, e.g. nav("/path", "Label", "Section").`
    )
  }
  return `nav_${slug}`
}

/** Event name for a collapsible group's toggle, derived from its label. */
export const groupName = label => `nav_group_${slugify(label)}`

/**
 * Sends the canonical vertical-nav click event. Mirrors the old horizontal
 * nav's "Element Clicked" shape so the two are comparable in Mixpanel, while
 * `location` distinguishes the surface (e.g. "vertical_nav", "dock_navigation",
 * "account_menu") and `is_mobile` captures the viewport.
 */
export function trackNavClick({
  name,
  text,
  elementType = "link",
  location,
  section,
  isMobile
}) {
  analytics.track(
    "Element",
    "Clicked",
    {
      element_type: elementType,
      name,
      text,
      location,
      section,
      is_mobile: isMobile
    },
    { transport: "beacon" }
  )
}
